import { getLevelUuidFromLevelNumber } from '@openeducation/oe-js-utils';
import { LevelUuid } from '@openeducation/oe-rn-shared-types';
import { styled } from '@openeducation/oe-rn-themes';
import React, { memo, useCallback } from 'react';

import LevelProgressBarItem from './level-progress-bar-item';

export interface LevelProgressBarProps {
  activeLevelNumber: string;
  activeLevelProgressPercent: number;
  levelNameByUuid: { [levelUuid: string]: string };
}

const levels = [
  LevelUuid.ONE,
  LevelUuid.TWO,
  LevelUuid.THREE,
  LevelUuid.FOUR,
  LevelUuid.FIVE,
  LevelUuid.SIX,
  LevelUuid.SEVEN,
  LevelUuid.EIGHT,
];

export const LevelProgressBar = ({
  activeLevelNumber,
  activeLevelProgressPercent,
  levelNameByUuid,
}: LevelProgressBarProps) => {
  const activeLevelUuid = getLevelUuidFromLevelNumber(activeLevelNumber);

  const renderItem = useCallback(
    (levelUuid: LevelUuid, index: number) => {
      return (
        <LevelProgressBarItem
          key={levelUuid}
          levelName={levelNameByUuid[levelUuid]}
          isActive={activeLevelUuid === levelUuid}
          isFinished={Number(activeLevelNumber) > index + 1}
          isFirst={index === 0}
          isLast={levels.length === index + 1}
          progressPercent={activeLevelProgressPercent}
        />
      );
    },
    [
      activeLevelUuid,
      activeLevelProgressPercent,
      activeLevelNumber,
      levelNameByUuid,
    ]
  );

  return <Container>{levels.map(renderItem)}</Container>;
};

const Container = styled.View`
  flex-direction: row;
  border-top-width: 1px;
  border-top-color: ${({ theme }) => theme.color.border};
  padding-top: 20px;
  max-width: 630px;
`;

export default memo(LevelProgressBar);
